<template>
  <ul>
    <li
      v-for="habbit in all"
      :key="habbit.id"
    >
      <div class="content">
        <button
          v-if="habbit.doneToday"
          class="button-icon"
          @click="untick(habbit.id)"
        >
          <FontAwesomeIcon
            icon="check-circle"
            class="icon-link done"
          />
        </button>
        <button
          v-else
          class="button-icon"
          @click="tick(habbit.id)"
        >
          <FontAwesomeIcon
            icon="check-circle"
            class="icon-link undone"
          />
        </button>
        <div class="title-box">
          <p class="title">
            {{ habbit.name }}
          </p>
          <p class="under">
            Last done: <strong> {{ habbit.lastDone }} </strong>
          </p>
        </div>

        <span class="right">
          <span class="dones">
            {{ habbit.done }} / {{ habbit.totalDays }}
          </span>
          <span>
            <button
              class="button-icon delete"
              @click="remove(habbit.id)"
            >
              <FontAwesomeIcon
                icon="times-circle"
                class="icon-link delete"
              />
            </button>
          </span>
        </span>
      </div>
      <div
        :class="`shadow ${habbit.doneToday ? 'done' : ''}`"
        style="width: 100%;"
      />
    </li>
  </ul>
</template>

<script>
import datetime from '@/helpers/datetime';

export default {
  name: 'ListHabbits',
  computed: {
    all() {
      return this.$store.state.habbits.map((habbit) => {
        const doneToday = datetime.isToday(habbit.lastDone);
        let lastDone = doneToday ? 'Today' : datetime.format(habbit.lastDoneTS || habbit.lastDone);
        if (habbit.lastDone === '1970-01-01') {
          lastDone = 'NEVER';
        }
        return Object.assign(
          {
            doneToday,
            totalDays: Math.floor((new Date(datetime.getTodaysDate()) - new Date(habbit.startedOn)) / (3600 * 24 * 1000) + 1),
          },
          habbit,
          {
            lastDone,
          },
        );
      });
    },
  },

  methods: {
    tick(id) {
      console.log(`Marking ${id} as done`);
      return this.$store.commit('tick', id);
    },
    remove(id) {
      console.log(`Removing ${id}`);
      return this.$store.commit('remove', id);
    },
    untick(id) {
      console.log(`Marking ${id} as not done`);
      return this.$store.commit('untick', id);
    },
  },
};
</script>

<style lang="scss" scoped>
//colors
$green_10: rgba(0, 255, 0, 0.1);
$color_santas_gray_approx: #99a;
$color_forest_green_approx: #118811;
$color_sandrift_approx: #aa8888;

//fonts
$font_0: Raleway;
$font_1: serirf;

ul {
  font-family: $font_0, $font_1;
  width: 100%;
  padding: 0;
  //Instead of the line below you could use @include box-sizing($bs)
  box-sizing: content-box;
  list-style-type: none;
}
li {
  padding: 1em 0;
  position: relative;
  padding-right: 1em;
}
.title-box {
  display: inline-block;
  padding-left: 0.5em;
  p {
    margin: 0;
    padding: 0;
  }
}
.button-icon {
  border: 0;
  cursor: pointer;
  background: none;
  font-size: 2em;
  vertical-align: top;
}
.title {
  font-size: 1.5em;
  padding: 0;
  margin: 0;
}
.under {
  font-size: 0.8em;
}
.content {
  z-index: 2;
  background: transparent;
}
.shadow {
  height: 80%;
  top: 10%;
  position: absolute;
  padding: 0.2em;
  //Instead of the line below you could use @include box-sizing($bs)
  box-sizing: content-box;
  z-index: -1;
}
.shadow.done {
  background: $green_10;
}
.dones {
  font-size: 1.5em;
}
.icon-link {
  color: $color_santas_gray_approx;
  &.delete {
    font-size: 0.5em;
    position: absolute;
    right: 0.2em;
    color: $color_sandrift_approx;
  }
}
.done {
  color: $color_forest_green_approx;
}
button:focus {
  outline: none;
}
</style>
